import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthorReleasePage } from './AuthorReleasePage';

export const Content_releaseRoutes: FC = () => (
	<Routes>
		<Route path='liberacao-de-autores' element={<AuthorReleasePage />} />
	</Routes>
);
